/* istanbul ignore file */
import { applyMiddleware, compose, createStore } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import createRootReducer from './reducers';
import { createReduxHistoryContext, reachify } from 'redux-first-history';
import { createBrowserHistory } from 'history';
import logger from 'redux-logger';

const {
    createReduxHistory,
    routerMiddleware,
    routerReducer
} = createReduxHistoryContext({
    history: createBrowserHistory()
});

function configureStoreProd(initialState = {}) {
    // const reactRouterMiddleware = routerMiddleware(history);
    const middlewares = [thunk, routerMiddleware];
    const store = createStore(
        createRootReducer(routerReducer), // root reducer with router state
        initialState,
        compose(applyMiddleware(...middlewares))
    );
    const history = createReduxHistory(store);
    return { store, history: reachify(history) };
}

function configureStoreDev(initialState = {}) {
    // const reactRouterMiddleware = routerMiddleware(history);
    const middlewares = [
        // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
        reduxImmutableStateInvariant(),
        thunk,
        routerMiddleware,
        logger
    ];
    const composeEnhancers =
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools

    const reducer = createRootReducer(routerReducer);

    const store = createStore(
        reducer, // root reducer with router state
        initialState,
        composeEnhancers(applyMiddleware(...middlewares))
    );
    const history = createReduxHistory(store);
    return { store, history: reachify(history) };
}

const configureStore =
    process.env.NODE_ENV === 'production'
        ? configureStoreProd
        : configureStoreDev;

export default configureStore;
